import { apiFetch, apiFetchLong } from './api';

export function getSessions(params = {}) {
  const query = new URLSearchParams(
    Object.entries(params).filter(([, value]) => value !== undefined && value !== null && value !== '')
  ).toString();

  return apiFetch(`/calendrier${query ? `?${query}` : ''}`);
}

export function getSessionById(id) {
  return apiFetch(`/calendrier/${id}`);
}

export function createSession(data) {
  return apiFetch('/calendrier', { method: 'POST', body: JSON.stringify(data) });
}

export function updateSession(id, data) {
  return apiFetch(`/calendrier/${id}`, { method: 'PUT', body: JSON.stringify(data) });
}

/** Analyse un texte collé (catalogue, mail) : renvoie des propositions de sessions. */
/** Le texte du calendrier public d'echo-cse.fr : { url, texte, caracteres }. */
export function texteCalendrierSite() {
  return apiFetch('/calendrier/import/site-texte');
}

/** Le calendrier public lu tel quel (sans IA) : { propositions, meta }. */
export function analyserImportSessionsSite() {
  return apiFetch('/calendrier/import/site', { method: 'POST' });
}

/** Supprime une sélection de sessions ; celles qui ont des places réservées restent. */
export function supprimerSessions(ids) {
  return apiFetch('/calendrier/supprimer', { method: 'POST', body: JSON.stringify({ ids }) });
}

/** Vide le calendrier avant un import complet ; les sessions réservées restent. */
export function supprimerToutesSessions() {
  return apiFetch('/calendrier/tout', { method: 'DELETE' });
}

export function analyserImportSessions(texte) {
  return apiFetchLong('/calendrier/import/analyser', {
    method: 'POST',
    body: JSON.stringify({ texte }),
  });
}

/** Enregistre les sessions retenues après relecture. */
export function enregistrerImportSessions(sessions) {
  return apiFetch('/calendrier/import/enregistrer', {
    method: 'POST',
    body: JSON.stringify({ sessions }),
  });
}

export function deleteSession(id) {
  return apiFetch(`/calendrier/${id}`, { method: 'DELETE' });
}
